import { render, staticRenderFns } from "./PromotionsModal.vue?vue&type=template&id=772f4b2e&scoped=true"
import script from "./PromotionsModal.vue?vue&type=script&lang=js"
export * from "./PromotionsModal.vue?vue&type=script&lang=js"
import style0 from "./PromotionsModal.vue?vue&type=style&index=0&id=772f4b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f4b2e",
  null
  
)

export default component.exports